export default __webpack_public_path__ + "static/media/journeytray-graytree.25547286.svg";